import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import ForgotPassword from "../components/ForgotPassword";
import { Helmet } from "react-helmet-async";


const ForgotPasswordPage = () => {



  return (
    <>

      <Helmet>
        <title> Reset Password | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Account"} />

      {/* Account */}
      <ForgotPassword />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  );
};

export default ForgotPasswordPage;